/* Club Perfume Árabe · JS del tema (sin dependencias) */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const moneda = () => (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  const dinero = cents => new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: moneda() }).format(cents / 100);
  let tToast;
  const aviso = t => { const el = $('#Toast'); if (!el) return; el.textContent = t; el.classList.add('ver'); clearTimeout(tToast); tToast = setTimeout(() => el.classList.remove('ver'), 2600); };

  /* ---------- Menú móvil ---------- */
  const menu = $('#MenuMovil'), bMenu = $('[data-abrir-menu]');
  const cerrarMenu = () => { if (!menu) return; menu.hidden = true; bMenu && bMenu.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; bMenu && bMenu.focus(); };
  bMenu && bMenu.addEventListener('click', () => { menu.hidden = false; bMenu.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; const c = $('[data-cerrar-menu]'); c && c.focus(); });
  $('[data-cerrar-menu]') && $('[data-cerrar-menu]').addEventListener('click', cerrarMenu);

  /* ---------- Carrito lateral ---------- */
  const cajon = $('#CartDrawer'), velo = $('[data-velo]');
  let focoPrevio = null;
  const abrir = () => {
    if (!cajon) return;
    focoPrevio = document.activeElement;
    cajon.classList.add('ver'); velo && velo.classList.add('ver'); cajon.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => { const c = $('[data-cerrar-carrito]'); c && c.focus(); }, 60);
  };
  const cerrar = () => {
    if (!cajon) return;
    cajon.classList.remove('ver'); velo && velo.classList.remove('ver'); cajon.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    focoPrevio && focoPrevio.focus && focoPrevio.focus();
  };
  $$('[data-abrir-carrito]').forEach(a => a.addEventListener('click', e => {
    if (!cajon || document.body.classList.contains('plantilla-cart')) return;
    e.preventDefault(); abrir();
  }));
  velo && velo.addEventListener('click', cerrar);
  document.addEventListener('click', e => { if (e.target.closest('[data-cerrar-carrito]')) cerrar(); });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    if (cajon && cajon.classList.contains('ver')) cerrar();
    if (menu && !menu.hidden) cerrarMenu();
  });

  const pintarCajon = html => {
    if (!html) return;
    const nuevo = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawerInner');
    const actual = $('#CartDrawerInner');
    if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;
  };
  const refrescarContador = async () => {
    try {
      const c = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      $$('[data-contador]').forEach(b => { b.textContent = c.item_count; b.hidden = c.item_count === 0; });
      $$('[data-abrir-carrito]').forEach(a => a.setAttribute('aria-label', `Carrito, ${c.item_count} productos`));
    } catch (e) { /* sin conexión */ }
  };
  const refrescarCajon = async () => {
    try {
      const r = await fetch(`${window.location.pathname}?sections=cart-drawer`);
      const j = await r.json();
      pintarCajon(j['cart-drawer']);
    } catch (e) { /* ignorar */ }
  };

  /* Añadir al carrito sin recargar (incluye regalo del pack de 3) */
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form.form-anadir');
    if (!form || !cajon) return;
    e.preventDefault();
    const boton = form.querySelector('[type=submit]');
    const html = boton ? boton.innerHTML : '';
    if (boton) { boton.disabled = true; boton.textContent = 'Añadiendo…'; }
    const id = +form.querySelector('[name=id]').value;
    const cantidadEl = form.querySelector('[name=quantity]');
    const cantidad = cantidadEl ? Math.max(1, +cantidadEl.value || 1) : 1;
    const regalo = +(form.dataset.regalo || 0);
    const items = [{ id, quantity: cantidad }];
    if (regalo && cantidad >= 3) items.push({ id: regalo, quantity: 1 });
    try {
      const r = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: ['cart-drawer'], sections_url: window.location.pathname })
      });
      const res = await r.json();
      if (res.status) { aviso(res.description || res.message || 'No se ha podido añadir.'); return; }
      if (res.sections && res.sections['cart-drawer']) pintarCajon(res.sections['cart-drawer']);
      else await refrescarCajon();
      await refrescarContador();
      abrir();
    } catch (err) {
      aviso('Algo ha fallado. Inténtalo de nuevo.');
    } finally {
      if (boton) { boton.disabled = false; boton.innerHTML = html; }
    }
  });

  /* Cambiar cantidades en el carrito lateral */
  const cambiarLinea = async (linea, cantidad) => {
    cajon.classList.add('cargando');
    try {
      const r = await fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: linea, quantity: cantidad, sections: ['cart-drawer'], sections_url: window.location.pathname })
      });
      const res = await r.json();
      if (res.status) aviso(res.description || res.message || 'No se ha podido actualizar.');
      else if (res.sections) pintarCajon(res.sections['cart-drawer']);
      await refrescarContador();
    } finally { cajon.classList.remove('cargando'); }
  };
  cajon && cajon.addEventListener('click', e => {
    const b = e.target.closest('[data-cambiar]');
    if (b) { cambiarLinea(+b.closest('[data-linea]').dataset.linea, Math.max(0, +b.dataset.cambiar)); return; }
    const q = e.target.closest('[data-linea-quitar]');
    if (q) cambiarLinea(+q.dataset.lineaQuitar, 0);
  });

  /* ---------- Ficha de producto ---------- */
  $$('[data-producto]').forEach(pdp => {
    const json = $('[data-producto-json]', pdp);
    const producto = json ? JSON.parse(json.textContent) : null;
    if (!producto) return;
    const d = { 1: 0, 2: +pdp.dataset.d2 || 0, 3: +pdp.dataset.d3 || 0 };
    const inputId = $('[data-variante-id]', pdp);
    const inputCant = $('[data-cantidad]', pdp);
    const boton = $('[data-boton-anadir]', pdp);
    const seccion = pdp.parentElement;
    const fija = seccion.parentElement.querySelector('[data-fija]') || (pdp.nextElementSibling && pdp.nextElementSibling.matches('[data-fija]') ? pdp.nextElementSibling : null);
    let variante = producto.variants.find(v => String(v.id) === String(inputId.value)) || producto.variants[0];

    const packActual = () => { const r = $('[data-pack]:checked', pdp); return r ? +r.value : 1; };
    const totalPack = n => Math.round(variante.price * n * (100 - d[n]) / 100);
    const antesPack = n => Math.max(variante.compare_at_price || 0, variante.price) * n;

    const pintar = () => {
      const n = packActual();
      inputCant.value = n;
      $$('[data-pack-total]', pdp).forEach(el => { el.textContent = dinero(totalPack(+el.dataset.packTotal)); });
      $$('[data-pack-antes]', pdp).forEach(el => { const k = +el.dataset.packAntes; el.textContent = dinero(antesPack(k)); el.hidden = antesPack(k) <= totalPack(k); });
      const actual = $('[data-precio-actual]', pdp), antes = $('[data-precio-antes]', pdp), dto = $('[data-dto]', pdp);
      const t = totalPack(n), a = antesPack(n);
      if (actual) actual.textContent = dinero(t);
      if (antes) { antes.hidden = a <= t; antes.textContent = dinero(a); }
      if (dto) { dto.hidden = a <= t; dto.textContent = `-${Math.round((1 - t / a) * 100)} %`; }
      const cta = $('[data-cta-precio]', pdp); if (cta) cta.textContent = dinero(t);
      if (fija) { const fp = $('[data-fija-precio]', fija); if (fp) fp.textContent = (n > 1 ? `${n} unidades · ` : '') + dinero(t); }
    };

    pdp.addEventListener('change', e => {
      if (e.target.matches('[data-pack]')) { pintar(); return; }
      if (!e.target.matches('[data-posicion]')) return;
      const elegidas = [1, 2, 3].map(p => { const r = $(`[data-posicion="${p}"]:checked`, pdp); return r ? r.value : null; });
      const v = producto.variants.find(v => v.options.every((o, i) => o === elegidas[i]));
      if (!v) { boton.disabled = true; boton.textContent = 'No disponible'; return; }
      variante = v;
      inputId.value = v.id;
      boton.disabled = !v.available;
      boton.innerHTML = v.available ? 'Añadir al carrito · <span data-cta-precio></span>' : 'Agotado';
      if (v.featured_media) verMedia(v.featured_media.id);
      pintar();
      if (document.body.classList.contains('plantilla-product')) {
        const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    });

    const verMedia = id => {
      $$('[data-media-id]', pdp).forEach(i => { i.hidden = String(i.dataset.mediaId) !== String(id); });
      $$('[data-ver-media]', pdp).forEach(b => b.setAttribute('aria-current', String(b.dataset.verMedia) === String(id)));
    };
    $$('[data-ver-media]', pdp).forEach(b => b.addEventListener('click', () => verMedia(b.dataset.verMedia)));
    pintar();

    /* Barra fija */
    if (fija && 'IntersectionObserver' in window && boton) {
      const btnFija = $('[data-fija-btn]', fija);
      btnFija && btnFija.addEventListener('click', () => { const f = boton.closest('form'); f.requestSubmit ? f.requestSubmit(boton) : f.submit(); });
      new IntersectionObserver(([en]) => {
        const ver = !en.isIntersecting && en.boundingClientRect.top < 0;
        fija.classList.toggle('ver', ver);
        fija.setAttribute('aria-hidden', String(!ver));
        if (btnFija) btnFija.tabIndex = ver ? 0 : -1;
        document.body.classList.toggle('con-fija', ver);
      }).observe(boton);
    }
  });

  /* ---------- Cuenta atrás de envío ---------- */
  const relojes = $$('[data-envio-hoy]');
  if (relojes.length) {
    const tick = () => relojes.forEach(el => {
      const ahora = new Date(), dia = ahora.getDay();
      const corte = new Date(ahora); corte.setHours(+el.dataset.corte || 14, 0, 0, 0);
      if (dia > 0 && dia < 6 && ahora < corte) {
        const ms = corte - ahora, h = Math.floor(ms / 36e5), m = Math.floor(ms % 36e5 / 6e4), s = Math.floor(ms % 6e4 / 1e3);
        el.innerHTML = `Pide en <b>${h}h ${String(m).padStart(2, '0')}m ${String(s).padStart(2, '0')}s</b> y sale hoy`;
      } else {
        el.innerHTML = 'Pide ahora y sale el <b>próximo día laborable</b> a primera hora';
      }
    });
    tick(); setInterval(tick, 1000);
  }

  /* ---------- Pestañas de familia ---------- */
  $$('[data-familias-sec]').forEach(sec => {
    const botones = $$('[data-fam]', sec), tarjetas = $$('[data-rejilla] .perf', sec), vacio = $('[data-sin-resultados]', sec);
    botones.forEach(b => b.addEventListener('click', () => {
      botones.forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      const tag = b.dataset.fam;
      let visibles = 0;
      tarjetas.forEach(t => {
        const tags = (t.dataset.tags || '').split(' ');
        const ok = !tag || tags.includes(tag);
        t.hidden = !ok; if (ok) visibles++;
      });
      if (vacio) vacio.hidden = visibles > 0;
    }));
  });

  /* ---------- Recomendados ---------- */
  $$('[data-recomendados]').forEach(async el => {
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const nuevo = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recomendados]');
      if (nuevo && nuevo.innerHTML.trim()) el.innerHTML = nuevo.innerHTML;
    } catch (e) { /* ignorar */ }
  });

  /* ---------- Filtros de colección ---------- */
  const filtros = $('[data-filtros]');
  filtros && filtros.addEventListener('change', e => {
    if (e.target.matches('input[type=checkbox], select')) {
      $$('input[type=number]', filtros).forEach(i => { if (!i.value) i.disabled = true; });
      filtros.submit();
    }
  });
  document.addEventListener('click', e => { $$('.filtro[open]').forEach(dd => { if (!dd.contains(e.target)) dd.removeAttribute('open'); }); });
})();
